import React from "react";
import { VisuallyHidden } from "react-aria";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Clickable } from "../Clickables";

import styles from "./Dots.module.scss";

interface Props {
    activeIndexes: string[];
    totalSize: number;
    className: string;
    onClick: (index: number) => void;
}

export const Dots = ({
    activeIndexes,
    totalSize,
    className,
    onClick,
}: Props) => (
    <div className={concatClassNames([styles.root, className])}>
        {Array.from({ length: totalSize }).map((_, index) => {
            const index1 = `${index + 1}`;
            const active = activeIndexes.includes(index1);
            return (
                <Clickable
                    key={index}
                    className={active ? styles.dotActive : styles.dotInactive}
                    onClick={() => onClick(index)}
                >
                    <VisuallyHidden>{t`Jump to item ${index1}`}</VisuallyHidden>
                </Clickable>
            );
        })}
    </div>
);
